import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.trabalhador.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.trabalhador.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.trabalhador.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
       
        dispatch('ActionSetLista',err)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.trabalhador.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.trabalhador.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEvento = ({dispatch},payload)=>{
    if (payload.evento == '2300') {
        return serves.trabalhador.evento2300(payload).then(res => {
            dispatch('ActionSetListaEvento',res)
        }).catch(err => {
            dispatch('ActionSetListaEvento',err)
        })
    }else{
        return serves.trabalhador.evento2200(payload).then(res => {
            dispatch('ActionSetListaEvento',res)
        }).catch(err => {
            dispatch('ActionSetListaEvento',err)
        })
    }
        
}
export const ActionEventoLista = ({dispatch},payload)=>{
    return serves.trabalhador.eventolista(payload).then(res => {
        dispatch('ActionSetListaEvento',res)
    }).catch(err => {
        dispatch('ActionSetListaEvento',err)
    })
}
export const ActionEventoCadastro = ({dispatch},payload)=>{
    return serves.trabalhador.eventocadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}

export const ActionListaDocumento = ({dispatch},payload)=>{
    return serves.trabalhador.documento(payload).then(res => {
        dispatch('ActionSetListaDocumento',res)
    }).catch(err => {
        dispatch('ActionSetListaDocumento',err)
    })
}
export const ActionEventoDeleta = ({dispatch},payload)=>{
    if (payload.evento === '2300') {
        return serves.trabalhador.eventodelete2300(payload).then(res => {
            dispatch('ActionSetListaEvento',res)
        }).catch(err => {
            dispatch('ActionSetListaEvento',err)
        })
    }else{
        return serves.trabalhador.eventodelete2200(payload).then(res => {
            dispatch('ActionSetListaEvento',res)
        }).catch(err => {
            dispatch('ActionSetListaEvento',err)
        })
    }
}
export const ActionEventoUpdate = ({dispatch},payload)=>{
    if (payload.evento === '2300') {
        return serves.trabalhador.eventoupdate2300(payload).then(res => {
            dispatch('ActionSetListaEvento',res)
        }).catch(err => {
            dispatch('ActionSetListaEvento',err)
        })
    }else{
        return serves.trabalhador.eventoupdate2200(payload).then(res => {
            dispatch('ActionSetListaEvento',res)
        }).catch(err => {
            dispatch('ActionSetListaEvento',err)
        })
    }
}
export const ActionMatricula = ({dispatch},payload)=>{
    return serves.trabalhador.matricula(payload).then(res => {
        dispatch('ActionSetMatricula',res)
    }).catch(err => {
        dispatch('ActionSetMatricula',err)
    })
}
export const ActionPefil = ({dispatch},payload)=>{
    return serves.trabalhador.perfil(payload).then(res => {
        dispatch('ActionSetPerfil',res)
    }).catch(err => {
        dispatch('ActionSetPerfil',err)
    })
}

export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}

export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetListaEvento = ({commit},payload) =>{
    commit(types.SET_LISTAEVENTO,payload)
}
export const ActionSetListaDocumento = ({commit},payload) =>{
    commit(types.SET_LISTADOCUMENTO,payload)
}
export const ActionSetMatricula = ({commit},payload) =>{
    commit(types.SET_MATRICULA,payload)
}
export const ActionSetPerfil = ({commit},payload) =>{
    commit(types.SET_PERFIL,payload)
}
